import { useEffect } from "react";
import Breadcrumb from "../Breadcrumb";
import SearchForm from "../SearchForm";
import "./index.css";

const BreadcrumbSearch = (props) => {
  useEffect(() => {
    if (document.querySelector(".sh-breadcrumb-wrapper").childNodes.length === 0) {
      document.querySelector(".sh-search-wrapper").classList.remove("col-md-8");
      document.querySelector(".sh-search-wrapper").classList.add("col-md-12");
    }
  }, []);
  return (
    <section className="sh-bread-search container">
      <div className="row">
        <div className="col-md-4 sh-breadcrumb-wrapper">
          {/* <Breadcrumb provinces={props.provinces} candidates={props.candidates} /> */}
        </div>
        <div className="col-md-8 sh-search-wrapper">{props.showSearch && <SearchForm tab={props.tab} provinces={props.provinces} searchParam={props.searchParam} handleSearch={props.handleSearch} />}</div>
      </div>
    </section>
  );
};

export default BreadcrumbSearch;
